import { DeliveryMode, FulfillmentMode, type IOrderPackage } from '@admin-panel/types';

/** Hub's new central dispatch audience is not a warehouse lifecycle permission. */
export const isJitAssignmentOnlyUser = (roles: Array<{ name?: string } | string> | undefined) => {
  const names = (roles ?? []).map(role => (typeof role === 'string' ? role : role.name));
  return (
    names.includes('RIDER_MANAGER') &&
    !names.some(role =>
      ['SUPER_ADMIN', 'WAREHOUSE_ADMIN', 'WAREHOUSE_MANAGER', 'WAREHOUSE_EXECUTIVE'].includes(
        role ?? '',
      ),
    )
  );
};
export const isJitAssignmentPackageScope = (pkg?: IOrderPackage) =>
  pkg?.fulfillmentMode === FulfillmentMode.JIT &&
  pkg.brandJitFulfillmentModel === 'B2B2C' &&
  pkg.deliveryMode === DeliveryMode.HOME_DELIVERY &&
  pkg.isInternational !== true &&
  pkg.tryAtHome !== true;
